import script from "./CategoriesStep.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoriesStep.vue?vue&type=script&setup=true&lang=ts"

import "./CategoriesStep.vue?vue&type=style&index=0&id=00f358f7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00f358f7"]])

export default __exports__